theme.headerSection = (function () {
  /* How long the mobile menu may sit untouched before it closes itself.
     Counted from the last real interaction inside the menu, not from opening. */
  const MOBILE_MENU_INACTIVITY_MS = 30000;

  function header() {
    /* Mobile Menu Function */
    const offcanvasHeader = function () {
      const offcanvasOpen = document.querySelector(
          ".header__actions_btn--menu"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasMenu = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      /* One timer for the whole menu, so a closed session can never leave a
         pending auto-close behind that fires into the next one */
      let inactivityTimer = null;

      const clearInactivityTimer = function () {
        if (inactivityTimer !== null) {
          clearTimeout(inactivityTimer);
          inactivityTimer = null;
        }
      };

      const closeOffcanvas = function () {
        clearInactivityTimer();
        offcanvasHeader.classList.remove("open");
        body.style.overflowY = null;
      };

      /* Every interaction inside the menu restarts the countdown from zero */
      const restartInactivityTimer = function () {
        clearInactivityTimer();
        if (!offcanvasHeader.classList.contains("open")) return;
        inactivityTimer = setTimeout(closeOffcanvas, MOBILE_MENU_INACTIVITY_MS);
      };

      const openOffcanvas = function () {
        offcanvasHeader.classList.add("open");
        body.style.overflowY = "hidden";
        restartInactivityTimer();
      };

      /* Add a Button For SubMenu Toggle */
      offcanvasMenu.forEach((item) => {
        item
        .querySelectorAll(".offcanvas__sub_menu")
        .forEach(function (ul) {
          const subMenuToggle = document.createElement("button");
          subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
          subMenuToggle.setAttribute("aria-label", "menu collapse");
          ul.parentNode.appendChild(subMenuToggle);

          /* Make the parent menu item open the submenu instead of navigating */
          const parentLink = ul.previousElementSibling;
          if (parentLink && parentLink.matches(".offcanvas__menu_item, .offcanvas__sub_menu_item")) {
            parentLink.addEventListener("click", function (e) {
              e.preventDefault();
              subMenuToggle.click();
            });
          }
        });


      });
      
      /* Open/Close Menu On Click Toggle Button */
      offcanvasOpen.addEventListener("click", function (e) {
        e.preventDefault();
        openOffcanvas();
      });
      offcanvasClose.addEventListener("click", function (e) {
        e.preventDefault();
        closeOffcanvas();
      });

      /* Keep the menu alive while it is being used. One listener per kind of
         input on the drawer itself, instead of one per menu item. */
      offcanvasHeader.addEventListener("pointerdown", restartInactivityTimer);
      offcanvasHeader.addEventListener("keydown", restartInactivityTimer);
      offcanvasHeader.addEventListener("touchmove", restartInactivityTimer, {
        passive: true,
      });
      /* scroll does not bubble, so it has to be caught on the way down */
      offcanvasHeader.addEventListener("scroll", restartInactivityTimer, {
        capture: true,
        passive: true,
      });
      
      
      /* Open/Close Sub Menu On Click Toggle Button */
      offcanvasMenu.forEach((offcanvasMenuitem) => {
        offcanvasMenuitem
        .querySelectorAll(".offcanvas__sub_menu_toggle")
        .forEach(function (toggle) {
          toggle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const parent = this.parentElement;
            if (parent.classList.contains("active")) {
              this.classList.remove("active");
              parent.classList.remove("active");
              parent
              .querySelectorAll(".offcanvas__sub_menu")
              .forEach(function (subMenu) {
                subMenu.parentElement.classList.remove("active");
                subMenu.nextElementSibling.classList.remove("active");
                slideUp(subMenu);
              });
            } else {
              this.classList.add("active");
              parent.classList.add("active");
              slideDown(this.previousElementSibling);
              getSiblings(parent).forEach(function (item) {
                item.classList.remove("active");
                item
                .querySelectorAll(".offcanvas__sub_menu")
                .forEach(function (subMenu) {
                  subMenu.parentElement.classList.remove("active");
                  subMenu.nextElementSibling.classList.remove("active");
                  slideUp(subMenu);
                });
              });
            }
          });
        });                   
      })
      

      document.addEventListener("click", function (event) {
        /* Only a real tap outside the menu closes it. Scripted clicks elsewhere
           on the page, such as the review carousel advancing itself, are not
           the customer leaving the menu. */
        if (!event.isTrusted) return;
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.classList.contains(
            ".header__actions_btn--menu".replace(/\./, "")
          )
        ) {
          if (
            !event.target.closest(".offcanvas-header") &&
            !event.target.classList.contains(
              ".offcanvas-header".replace(/\./, "")
            )
          ) {
            closeOffcanvas();
          }
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width in More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992) {
          closeOffcanvas();
        }
      });
    };
    /* Mobile Menu Active */
    offcanvasHeader();
  }

  return header;
})();
